import Raygun from './Raygun'

export default {
  mixins: [Raygun],

  methods: {
    submitLead (journeyName, data, notasOptions = {}) {
      this.$gtm.trackEvent({
        event: 'GAEvent',
        eventCategory: 'conversion',
        eventAction: 'journey',
        eventLabel: journeyName
      })

      return this.$store.dispatch('actionUpdateCallBackData', data)
        .then(() => {
          return this.$store.dispatch('actionCreateLead')
            .then(response => {
              this.$router.push('confirmation')
            })
            .catch(response => {
              this.logError(response)
              this.$router.push('error')
            })
        })
        //  DARENTODO: change to sessionwarehouse?

      // .then(() => {
      //   return this.$store.dispatch('postNotas', { ...notasOptions, isConversion: true })
      // }).catch(error => this.logError(error))
    }
  }
}
